export const boardEn = {
  toolbar: {
    actionsAria: 'Board actions',
    groups: 'Groups:',
    players: 'Players:',
    filters: 'Filters',
    openFilters: 'Open player filters',
    openActiveFilters: (mode: string, count: number) => `Open ${mode} player filters, ${count} active`,
    viewOnly: "View-only — only officers and the Discord owner can edit this guild's board.",
    openMap: 'Open raid tactical map',
    map: 'Map',
    raidAudit: 'Raid audit',
    raidAuditAria: 'Open this raid audit log',
    cloneRaidAria: 'Clone another raid from the calendar',
    cloneRaid: 'Clone another raid',
    publish: 'Publish',
    unpublish: 'Unpublish',
    publishAria: 'Publish raid',
    unpublishAria: 'Unpublish raid',
    switchToDetail: 'Switch to detail view',
    switchToCompact: 'Switch to compact view',
    compact: 'Compact',
    detail: 'Detail',
    playerNameModeAria: 'Player name display',
    guildNickname: 'Guild',
    playerNickname: 'Player',
    playerAccountName: 'Account',
    showGuildNickname: 'Show Discord guild nicknames',
    showPlayerNickname: 'Show Discord player nicknames',
    showPlayerAccountName: 'Show Discord account names',
    sortAria: 'Sort all groups by role (shortcut: s)',
    sort: 'Sort',
    resetAria: 'Reset board to seed',
    reset: 'Reset',
    sortedAnnouncement: 'Sorted every group by role',
    resetAnnouncement: 'Board reset to seed data',
    resetConfirm: 'Reset the board to seed data? This will discard all changes.',
  },
  player: {
    assignTagError: 'Could not assign tag. Please try again.',
    signedUp: 'Signed up',
    signedUpAria: 'Signed up for this raid',
    notSignedUp: 'Not signed up',
    notSignedUpAria: 'Not signed up for this raid',
    signInRaid: 'Sign in',
    signInRaidAria: 'Sign in to this raid',
    signOutRaid: 'Sign out',
    signOutRaidAria: 'Sign out of this raid',
    rsvpPending: 'Updating…',
    rsvpError: 'Could not update your raid sign-up. Please try again.',
    rsvpSyncTimeout: 'The raid update is taking longer than expected. Live sync will apply it when it arrives.',
    signedIn: 'Signed in',
    signedInAria: 'Signed in to the planner',
    notSigned: 'Not signed',
    notSignedAria: 'Not signed in to the planner',
    inGame: 'In-game',
    addEmoji: 'Add emoji to in-game name',
    filterByTag: (tag: string) => `Filter by tag '${tag}'`,
    toggleTagFilter: (tag: string) => `Toggle filter for tag ${tag}`,
    additionalTagsDescription: (names: string) => `Additional tags: ${names}`,
  },
  dropZone: {
    dropHere: 'Drop players here',
    noMatching: 'No matching players',
    noPlayers: 'No players',
  },
  group: {
    fallbackName: (index: number) => `Group ${index}`,
    setName: (index: number) => `Set name for Group ${index}`,
    rename: (name: string | number) => `Rename group ${name}`,
    unlimited: 'Unlimited',
    capacityError: 'Group is over or under capacity',
    maxPlayers: (name: string) => `Max players for ${name}`,
    expand: (name: string) => `Expand ${name}`,
    collapse: (name: string) => `Collapse ${name}`,
    selectPlayers: (name: string) => `Select players for ${name}`,
  },
  role: {
    tank: 'TANK',
    dps: 'DPS',
    hybrid: 'HYBRID',
    heal: 'HEAL',
    nameless: 'NAMELESS',
    unarmed: 'unarmed',
    badgeTitle: (role: string, left: string, right: string) => `Role: ${role} — weapons: ${left} / ${right}`,
    statsTank: 'Tank',
    statsDps: 'DPS',
    statsHybrid: 'Hybrid',
    statsHealer: 'Healer',
  },
  room: {
    renameTitle: (name: string) => `Rename ${name}`,
    editableNameAria: (name: string) => `Room name: ${name}. Click to rename.`,
    nameAria: (name: string) => `Room name: ${name}`,
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    layoutDescription: (room: string, current: string, target: string) => `Group layout for ${room}: ${current}. Click to switch to ${target}.`,
    moveUp: (name: string) => `Move ${name} up`,
    moveDown: (name: string) => `Move ${name} down`,
    moveUpTitle: 'Move room up',
    moveDownTitle: 'Move room down',
    removeAria: (name: string) => `Remove room ${name}`,
    removeTitle: 'Remove room',
    removeConfirm: (name: string) => `Remove room "${name}"? All its groups will be deleted and their players returned to the pool.`,
    stageTitle: (name: string) => `Stage: ${name}`,
    stageAria: (name: string) => `Stage ${name}`,
    stage: 'Stage',
  },
}
